module.exports = __webpack_public_path__ + "static/media/18(2).3697ebf6.jpg";